import React from "react";
import { useNavigate } from "react-router-dom";

function BuildingName({ params }) {
  const redirect = useNavigate();
  return (
    <>
      <p
        className="cursor-pointer underline"
        onClick={() =>
          redirect(
            `/client/${params.row.client_id}/building/${params.row.building_id}?year=${new Date().getFullYear()}`
          )
        }
      >
        {params.row.address}
      </p>
    </>
  );
}

export default BuildingName;
